import quizTypesRules from "./quizTypesRules"
import quizAssignPlatformRules from "./quizAssignPlatformRules"
import quizResourcesRules from "./quizResourcesRules"
export default {
    quizTypesRules,quizAssignPlatformRules,quizResourcesRules
}